module.exports = __webpack_public_path__ + "media/bootstrap-icons/chevron-bar-up-6e25079b.svg";